import { useMutation } from '@apollo/client';
import { gql } from '__generated__';
import { DepartmentType } from '__generated__/graphql';
import { FC } from 'react';

import { FormInput, FormPanelWithReadMode } from 'components/FormPanel';

import { getUserRole } from 'utils/auth';

const UPDATE_DEPARTMENT_MUTATION = gql(`
  mutation UpdateDepartment(
    $id: ID!
    $name: String!
    $shortName: String!
    $cardNumberPrefix: String
    $status: DepartmentStatusEnumType!
    $logo: Upload
  ) {
    updateDepartment(
      id: $id
      name: $name
      shortName: $shortName
      cardNumberPrefix: $cardNumberPrefix
      status: $status
      logo: $logo
    ) {
      id
      name
      shortName
      logo
      cardNumberPrefix
      status
      updatedAt
      createdAt
    }
  }
`);

const UpdateDepartment: FC<{
  department: DepartmentType;
}> = ({ department }) => {
  const [updateDepartment, { loading, error }] = useMutation(UPDATE_DEPARTMENT_MUTATION);

  const userRole = getUserRole();

  return (
    <FormPanelWithReadMode
      loading={loading}
      error={error}
      disableEdit={!['SUPER_ADMIN', 'ADMIN'].includes(userRole)}
      onSubmit={data => {
        updateDepartment({
          variables: {
            id: department.id,
            name: data.name,
            shortName: data.shortName,
            cardNumberPrefix: data.cardNumberPrefix,
            status: data.status,
            logo: data.logo instanceof File ? data.logo : undefined,
          },
        });
      }}
    >
      <FormInput
        fullWidth
        type="string"
        fieldName="name"
        label="Name"
        defaultValue={department.name}
        validators={{
          required: true,
        }}
      />
      <FormInput
        fullWidth
        type="string"
        fieldName="shortName"
        label="Short Name"
        defaultValue={department.shortName}
        validators={{
          required: true,
        }}
      />
      <FormInput
        fullWidth
        type="string"
        fieldName="cardNumberPrefix"
        label="Card Number Prefix"
        defaultValue={department.cardNumberPrefix}
      />
      <FormInput
        fieldName="logo"
        type="upload"
        fullWidth
        defaultValue={department.logo || ''}
        label="Department Logo"
      />
      <FormInput
        fullWidth
        type="status_select"
        fieldName="status"
        label="Status"
        defaultValue={department.status}
        validators={{
          required: true,
        }}
        statusOptions={['INACTIVE', 'ACTIVE']}
      />
    </FormPanelWithReadMode>
  );
};

export default UpdateDepartment;
